var map = {
	"./about-us.png": 9390,
	"./contact-header.jpg": 8783,
	"./error-404.png": 5110,
	"./header.jpg": 5572,
	"./hero-header-2.png": 7875,
	"./hero-header-3.png": 5156,
	"./hero-header-old.jpg": 3550,
	"./hero-header.png": 2924,
	"./instagram.png": 723,
	"./kathmandu.jpg": 884,
	"./linkedin.png": 5975,
	"./logo-tiktok.svg": 5182,
	"./logo.png": 5080,
	"./man.png": 1094,
	"./not-found.jpg": 2531,
	"./not-found.png": 3937,
	"./tiktok.png": 5355,
	"./whatsapp.png": 7567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4360;